// Central content + curated imagery for FTC Automotive
export const CONTACT = {
  phone: "07305 044721",
  phoneHref: "tel:+447305044721",
  email: "info@ftcautomotive.co.uk",
  emailHref: "mailto:info@ftcautomotive.co.uk",
  area: "Bristol · BS5 8AN & surrounding areas",
  owner: "Luke",
  ownerFull: "Luke R",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1688885387668-cb2238bd3822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxkYXJrJTIwY2luZW1hdGljJTIwY2FyJTIwd29ya3Nob3AlMjBlbmdpbmUlMjBiYXl8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
  legend: "https://images.unsplash.com/photo-1654616111851-5394318e3279?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxkYXJrJTIwY2luZW1hdGljJTIwY2FyJTIwd29ya3Nob3AlMjBlbmdpbmUlMjBiYXl8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
  manifesto: "https://images.unsplash.com/photo-1551670539-4c4e96906f87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjYXIlMjBlbmdpbmUlMjBtZWNoYW5pYyUyMGRldGFpbCUyMGRhcmt8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "transmission",
    n: "01",
    title: "Transmission & Clutches",
    copy: "Specialist gearbox rebuilding, heavy-duty manual & automatic clutch replacements, and complete drivetrain diagnostics.",
    img: "https://images.unsplash.com/photo-1780835438394-71fd522cbda9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxnZWFyYm94JTIwdHJhbnNtaXNzaW9uJTIwY2x1dGNoJTIwcGFydHN8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
    icon: "Cog",
  },
  {
    id: "diagnostics",
    n: "02",
    title: "Advanced Diagnostics",
    copy: "Dealer-grade electronic troubleshooting built to hunt down stubborn fault codes and electrical gremlins on the first pass.",
    img: "https://images.unsplash.com/photo-1727893380169-4dda123e19f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjYXIlMjBkaWFnbm9zdGljJTIwdG9vbCUyMGVsZWN0cm9uaWNzfGVufDB8fHx8MTc4Njc5Mzc3MXww&ixlib=rb-4.1.0&q=85",
    icon: "Activity",
  },
  {
    id: "engine",
    n: "03",
    title: "Engine Rebuilds & Fuel Systems",
    copy: "Major mechanical overhauls, precise fuel system servicing, and uncompromising internal engine care.",
    img: "https://images.unsplash.com/photo-1760688191183-860128db7a0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxkYXJrJTIwY2luZW1hdGljJTIwY2FyJTIwd29ya3Nob3AlMjBlbmdpbmUlMjBiYXl8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
    icon: "Flame",
  },
  {
    id: "maintenance",
    n: "04",
    title: "General Vehicle Maintenance",
    copy: "Routine servicing, brake overhauls, and full health assessments engineered for all makes and models.",
    img: "https://images.unsplash.com/photo-1706675804644-c8fa831038ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjYXIlMjBlbmdpbmUlMjBtZWNoYW5pYyUyMGRldGFpbCUyMGRhcmt8ZW58MHx8fHwxNzg2NzkzNzcxfDA&ixlib=rb-4.1.0&q=85",
    icon: "Wrench",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "No Corporate Nonsense",
    copy: "Direct, honest talk from a seasoned pro who tells you exactly what's broken, what it costs, and how it's getting fixed. No upsells. No waffle.",
  },
  {
    n: "02",
    title: "Master-Level Precision",
    copy: "Decades of hard-earned experience tackling complex engineering challenges that standard quick-fit garages run away from.",
  },
  {
    n: "03",
    title: "Bristol Built",
    copy: "Local, reliable, and equipped to handle workshop-grade precision with zero hassle — right here in BS5.",
  },
];

export const ABOUT = "With IMI Levels 1–3 qualifications and over 30 years of combined industry experience, we specialise in a wide range of automotive services — fuel systems, transmission repairs, in-depth diagnostics, general vehicle maintenance, engine rebuilds and gearbox rebuilds. Committed to high-quality workmanship and accurate fault diagnosis, we deliver reliable, professional solutions for all makes and models.";

export const TRUST = [
  { stat: "30+", label: "Years Professional Experience" },
  { stat: "IMI 1–3", label: "Qualified & Official IMI Member" },
  { stat: "5.0★", label: "13+ Completed Bookings · Verified" },
];

export const GALLERY = [
  {
    id: "clutch",
    title: "Clutch & Dual Mass Flywheel",
    vehicle: "Nissan Qashqai",
    copy: "Burnt-out clutch and scored flywheel swapped for a brand-new kit. Smooth pedal, zero judder, back on the road same week.",
    before: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/0a578d88f8cfc1291c1e013bff5768170599b3d6605e3981e39230e96529e9f6.jpeg",
    after: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/c0a250b19f22239829b2af0bad00e53f49c5c269282db0ded2985e976ac5ddbe.jpeg",
  },
  {
    id: "engine",
    title: "Full Engine Rebuild & Detail",
    vehicle: "Ford Focus",
    copy: "Tired, oil-soaked engine bay stripped, rebuilt and dressed. Every hose, belt and seal replaced — runs like the day it left the factory.",
    before: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/82f48b606678c7e0e9cbb736b5d9dac049a20601db673cf17ee9fd808fd3a4ff.jpeg",
    after: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/aac696c4c5890ac5b5bdf2dc02199a479ccb6a14ab15ffb4156af6079c974215.jpeg",
  },
  {
    id: "brakes",
    title: "Brakes, Discs & Calipers",
    vehicle: "Citroën C4 Picasso",
    copy: "Rust-eaten discs and worn pads replaced with fresh discs, pads and calipers. Stopping power fully restored, MOT-ready.",
    before: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/4e20295b1ed1af3210fb3b68d0b2812225cf4d3110b429f8424ad0bf088e8aa9.jpeg",
    after: "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/9230635e20b327404689b01c5e92492d67d4e36f28117b472382e5736dde6712.jpeg",
  },
];

export const LUKE_IMG = "https://static.prod-images.emergentagent.com/jobs/61f961eb-925a-440f-84d9-9b4f973d2c14/images/25c19fbc640c664f92c8c0607123c28d1ef5852a338b0955e22ebbdd40a4b3ca.jpeg";

export const GUARANTEES = [
  {
    icon: "ShieldCheck",
    title: "Honest, Fixed Quotes",
    copy: "The price Luke quotes is the price you pay. No hidden extras, no surprise invoices, no upsells.",
  },
  {
    icon: "Camera",
    title: "Photo Proof, Every Job",
    copy: "You get before-and-after photos of the actual work on your vehicle — so you can see exactly what was done.",
  },
  {
    icon: "Truck",
    title: "Recovery Vehicle Available",
    copy: "Car won't drive? No stress. Luke can collect it with the recovery vehicle for a small charge.",
  },
  {
    icon: "HeartHandshake",
    title: "Treated Fair, Every Time",
    copy: "Down-to-earth, friendly and straight-talking. Your car is looked after like it's Luke's own.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Tell Luke What's Up",
    copy: "Book a slot online, ring the workshop, or drop a message. Describe the noise, the light, the leak — whatever it is.",
  },
  {
    n: "02",
    title: "Straight-Talk Quote",
    copy: "Luke calls you back, confirms exactly what's wrong and gives you an honest, fixed price. No jargon, no waffle.",
  },
  {
    n: "03",
    title: "Fixed & Back On The Road",
    copy: "Quality parts, master-level workmanship, and photos of the job. Most repairs turned around same-day.",
  },
];

export const REVIEWS = [
  {
    name: "Alexander",
    car: "Ford Focus — Water Pump Replacement",
    date: "23rd June 2026",
    stars: 5,
    text: "Straight-forward pricing and clear, timely communication. Luke arranged for the car to be picked up in the morning, completed the work same-day and dropped it back by the end of the day. Highly recommend.",
  },
  {
    name: "Michael",
    car: "Nissan X-Trail — Clutch Replacement",
    date: "9th July 2026",
    stars: 5,
    text: "Luke delivered a quality repair in a speedy manner. Very impressed with the service provided.",
  },
  {
    name: "Joseph",
    car: "Citroën Grand C4 Picasso — Clutch & Flywheel",
    date: "14th July 2026",
    stars: 5,
    text: "Very polite and went out of his way to make sure we had our car back as soon as possible. He even sent pictures of the job before and after.",
  },
  {
    name: "Stephen",
    car: "Nissan Qashqai — Clutch & Dual Mass Flywheel",
    date: "17th July 2026",
    stars: 5,
    text: "Luke was brilliant. Handled the task well even when the wrong part was quoted originally. More than happy with his work.",
  },
];
